export default __webpack_public_path__ + "static/lime-frame-bf1c7f588ca4b4e0800d1bafec1cd32f.png";